import { render, staticRenderFns } from "./MpPopupCard.vue?vue&type=template&id=24889dae&scoped=true&"
import script from "./MpPopupCard.vue?vue&type=script&lang=js&"
export * from "./MpPopupCard.vue?vue&type=script&lang=js&"
import style0 from "./MpPopupCard.vue?vue&type=style&index=0&id=24889dae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24889dae",
  null
  
)

export default component.exports